export default "__VITE_ASSET__baf9aaff__"